import script from "./DocsTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsTitle.vue?vue&type=script&setup=true&lang=js"

import "./DocsTitle.vue?vue&type=style&index=0&id=179dc7fa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179dc7fa"]])

export default __exports__